import { cEl } from '../../../../../util';
import { getTestResultClass, resultClassToDescription, TEST_KEY } from '../../constants';
import { calcTotalScore } from './index';

function ResultBox(test, noProgress) {
    const resultBox = cEl('div');
    resultBox.classList.add('result-box-wrapper');
    if (noProgress) {
        resultBox.innerHTML = `
        <div class="result-box">
            <span class="test-title">${test.key === TEST_KEY.READINESS ? '전반적 준비 정도' : test.title}</span>
            <div class="test-score">
                <span class="test-total-score">점수 없음</span>
                <div class="test-score-class">
                    <div class="class-bar"></div>     
                    <div class="class-circle red"></div>               
                    <div class="class-circle orange"></div>               
                    <div class="class-circle yellow"></div>               
                    <div class="class-circle blue"></div>               
                </div>        
            </div>
            <span class="test-class-description">테스트를 진행하지<br>않았습니다.</span>
        </div>
        `;
        return resultBox;
    }
    // 점수 null 가능
    const totalScore = test.computedScore ?? calcTotalScore(test);
    const resultClass = getTestResultClass(totalScore);
    resultBox.classList.add(resultClass);
    resultBox.innerHTML = `
        <div class="result-box">
            <span class="test-title">${test.key === TEST_KEY.READINESS ? '전반적 준비 정도' : test.title}</span>
            <div class="test-score">
                <span class="test-total-score">${totalScore} 점</span>
                <div class="test-score-class">
                    <div class="class-bar"></div>     
                    <div class="class-circle red"></div>               
                    <div class="class-circle orange"></div>               
                    <div class="class-circle yellow"></div>               
                    <div class="class-circle blue"></div>               
                </div>        
            </div>
            <span class="test-class-description">${resultClassToDescription[resultClass]}</span>
        </div>
    `;
    return resultBox;
}

export default ResultBox;
